import { AxiosInstance, AxiosResponse } from 'axios'
import * as Sentry from '@sentry/react'
import { BloomreachApiEndpoints, BloomreachPostSalonDetailBody } from '../types/types'

const postSalonDetail = async (client: AxiosInstance, reqBody: BloomreachPostSalonDetailBody): Promise<void> => {
	try {
		await client.post<any, AxiosResponse<any>, BloomreachPostSalonDetailBody>('/api/tracking/web/view/salon/', reqBody)
	} catch (error) {
		Sentry.captureException(error, { extra: { identifier: 'Bloomreach - postSalonDetail' } })
	}
}

const loadApiEndpoints = (client: AxiosInstance): BloomreachApiEndpoints => {
	return {
		postSalonDetail: (reqBody) => postSalonDetail(client, reqBody)
	}
}

export default loadApiEndpoints
